import type { Column } from 'react-table';

import {
    EllipsisCell,
    WorthCell,
    transformWorthString,
    transformDateString,
} from '@catalyze/ui';
import { Columns, ColumnsSortId } from 'constants/columns';

// Has to be exhaustive list of all visible columns
export const columnsPriority = [
    Columns.ADDRESS,
    Columns.CITY,
    Columns.STATE,
    Columns.ZIP,
    Columns.MARKET_VALUE,
    Columns.NEW,
    Columns.EDM,
    Columns.DATE_UPDATED,
    Columns.DATE_ADDED,
];

export const columnsConfig: Column[] = [
    {
        Header: 'Totals',
        accessor: Columns.ADDRESS,
        disableSortBy: true,
        columns: [
            {
                Header: 'Address',
                accessor: Columns.ADDRESS,
                id: ColumnsSortId.ADDRESS,
                maxWidth: 90,
                Cell: ({ value }) => (
                    <EllipsisCell highlighted>{value}</EllipsisCell>
                ),
                Filter: 'Filter',
            },
            {
                Header: 'City',
                accessor: Columns.CITY,
                id: ColumnsSortId.CITY,
                maxWidth: 90,
                Cell: ({ value }) => <EllipsisCell>{value}</EllipsisCell>,
            },
            {
                Header: 'State',
                accessor: Columns.STATE,
                id: ColumnsSortId.STATE,
                maxWidth: 50,
            },
            {
                Header: 'Zip',
                accessor: Columns.ZIP,
                id: ColumnsSortId.ZIP,
                maxWidth: 50,
            },
            {
                Header: 'EDM',
                accessor: Columns.EDM,
                id: ColumnsSortId.EDM,
                maxWidth: 50,
                Cell: ({ value }) => <EllipsisCell>{value}</EllipsisCell>,
            },
            {
                Header: 'Scenario',
                accessor: Columns.LEAD_TYPE,
                id: ColumnsSortId.LEAD_TYPE,
                maxWidth: 70,
                Cell: ({ value }) => <EllipsisCell>{value}</EllipsisCell>,
            },
            {
                Header: 'Date Added',
                accessor: Columns.DATE_ADDED,
                id: ColumnsSortId.DATE_ADDED,
                maxWidth: 70,
                Cell: ({ value }) =>
                    value ? transformDateString(new Date(value)) : null,
            },
        ],
    },
    {
        Header: ({ data }) => (
            <WorthCell alignRight>
                {transformWorthCellData(
                    data?.[0]?.[Columns.DISPLAYED_MARKET_VALUE],
                    data?.[0]?.[Columns.TOTAL_MARKET_VALUE]
                )}
            </WorthCell>
        ),
        id: ColumnsSortId.TOTAL_MARKET_VALUE,
        accessor: Columns.MARKET_VALUE,
        disableSortBy: true,
        columns: [
            {
                Header: 'Est. Market Value',
                accessor: Columns.MARKET_VALUE,
                id: ColumnsSortId.MARKET_VALUE,
                maxWidth: 100,
                Cell: ({ value }) => (
                    <WorthCell alignRight>
                        {transformWorthString(value)}
                    </WorthCell>
                ),
            },
        ],
    },
];

function transformWorthCellData(
    displayedMarketValue?: number,
    totalMarketValue?: string
): string {
    const displayValue = displayedMarketValue
        ? transformWorthString(displayedMarketValue)
        : transformWorthString(0);
    return totalMarketValue
        ? `${displayValue} / ${transformWorthString(
              parseInt(totalMarketValue, 10)
          )}`
        : displayValue;
}
